import { http } from '@/plugins/http';

export default {
  // 根据泛域名解析 子域名获取租户id
  getTenantId(predomain){
    return http({
      baseURL: window.CONFIG.USERAPI,
      method: 'get',
      url: '/tenant/' + predomain
    });
  }
}


// WEBPACK FOOTER //
// ./src/api/user/index.js